import DBTIQUIZ from "../../../../src/events/2022/04/dbti/quiz/main";
import * as React from 'react';
export default {
  DBTIQUIZ,
  React
};